import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";  // Import framer-motion

import IntroImg from "../assets/cn.jpg";
import "./HeroImgStyles.css";

const HeroImg = () => {
  return (
    <div className="hero">
      {/* Add animation to the image container */}
      <div className="mask">
        <motion.img 
          className="intro-img" 
          src={IntroImg} 
          alt="Intro Image" 
          initial={{ opacity: 0 }} 
          animate={{ opacity: 1 }} 
          transition={{ duration: 1 }} 
        />
      </div>

      <div className="content">
        {/* Add animation to the text */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          Hi, I'm Uriel, a Developer specialized in delivering high-quality solutions.
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1 }}
        >
          FULL-STACK DEVELOPER
        </motion.h1>

        <div>
          {/* Add animation to the buttons */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.5 }}
          >
            <Link to="/project" className="btn">Projects</Link>
            <Link to="/contact" className="btn btn-light">Contact</Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default HeroImg;
